// Shared public email choices. These are mailing topics, never access entitlements.
export const EMAIL_TOPIC_OPTIONS = [
  ["newsletter", "General newsletter"],
  ["events", "Events and gatherings"],
  ["feasts", "Feasts and appointed times"],
  ["lives", "Live broadcasts"],
  ["teachings", "Teachings"],
  ["studies", "Studies"],
  ["programs", "Programs and ministries"],
  ["weekly_summary", "Weekly summaries"],
  ["monthly_digest", "Monthly digests"],
  ["music", "Music and releases"],
  ["records", "Record label"],
  ["publishing", "Publishing and writers"],
  ["merch", "Merchandise"],
  ["tutorials", "Tutorials"],
  ["sneak_peeks", "Sneak peeks"],
  ["exclusives", "Exclusive announcements"],
  ["promotions", "Promotions"],
  ["subscribers", "Subscriber updates"],
  ["donations", "Support opportunities"],
];
export const EMAIL_ENROLLMENT_NOTICE =
  "Submitting this form enrolls or re-enrolls you in email updates about your selected interest and topics. You can change individual topics, program messages, or unsubscribe from all promotional emails using the link in every email. Signing up for updates does not provide restricted National or paid membership access.";
